import type {
  TAuthenticatedPlayerDetails,
  TPlayerId,
} from '@kapitalist/contract/types'
import {DataBackedModel} from '~/models/base'

/**
 * Represents the currently-logged-in human using the web client.
 * They may or may not be in a game right now - that's handled by
 * `GamePlayer` and its subclass `CurrentGamePlayer`.
 */
export default class AuthenticatedPlayer extends DataBackedModel<TAuthenticatedPlayerDetails> /* implements TAuthenticatedPlayerDetails */ {
  // i think `declare` is the correct thing to do here to make `implements TAuthenticatedPlayerDetails`
  // and the magic in DataBackedModel work
  // but it's broken right now: https://github.com/facebook/create-react-app/issues/8918
  // /* declare*/ email: string = ''
  // /* declare*/ username: string = ''

  id: TPlayerId
  username: string
  email: string
  admin: boolean

  constructor(playerDetails: TAuthenticatedPlayerDetails) {
    super(playerDetails)
    this.id = playerDetails.id
    this.email = playerDetails.email
    this.username = playerDetails.username
    this.admin = playerDetails.admin
  }
}
